// extracted by mini-css-extract-plugin
export default {"optionMain":"Options_optionMain__AEi6T","optionCard":"Options_optionCard__2Qma6","active":"Options_active__TA8JN","sourceText":"Options_sourceText__4rz8M"};